/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/breakpoint-change';
import Navigation from './components/navigation';
import Search from './components/search';
import FilterWindow from './components/filter-window';
import TeamCard from './components/team-card';
import Gallery from './components/gallery';
import PageIndex from './components/page-index';
import ArticleCheck from './article-check';
import { initDetailsAnimation } from './components/animate-details';
import './components/delay-search-queries';
import './components/fancybox';
import './components/scroll-to-top';

function registerComponent(selector, Component) {
	document.querySelectorAll(selector).forEach((node) => {
		return new Component(node);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	registerComponent('.navigation', Navigation);
	registerComponent('.team-card', TeamCard);
	registerComponent('.gallery', Gallery);
	registerComponent('.page-index', PageIndex);
	registerComponent('.search', Search);
	registerComponent('.article-check', ArticleCheck);

	// Initialize <details> animations
	initDetailsAnimation(document, true);

	const filterable = ['section.location-map', 'section.overview'];

	document.body.querySelectorAll(filterable.join(', ')).forEach((node) => {
		const id = node.getAttribute('data-filter-window');
		const target = document.getElementById(id);
		const openBtn = node.querySelector('.filter-window-open');

		if (target) {
			const filterWindow = new FilterWindow(target);
			openBtn?.addEventListener('click', () => {
				filterWindow?.openFilters();
			});
		}
	});

	document.querySelectorAll('.ginput_container_fileupload button.gform_button_select_files').forEach((btn) => {
		btn.setAttribute('class', 'btn primary compact');
	});
});

document.addEventListener('DOMContentLoaded', async () => {
	try {
		const res = await fetch('/wp-json/strl/v1/stock-data?code=NL0012866412&codification=ISIN&exchCode=XAMS');
		const data = await res.json();
		const instr = data.instr;

		const name = instr.shrtNm;
		const currentPrice = parseFloat(instr.currInstrSess.lastPx);
		const currencySymbol = instr.currency === 'EUR' ? '€' : instr.currency;

		const prevClose = parseFloat(instr.currInstrSess.prevAdjClosingPrice); // Previous adjusted close (to calculate % change)
		const changePct = ((currentPrice - prevClose) / prevClose) * 100; // Percent change
		const changeSign = changePct > 0 ? '+' : '-';

		// Current session timestamp
		const rawDate = instr.currInstrSess.dateTime; // e.g. "20251030-11:28:30"
		console.log(rawDate);
		const dateStr = `${rawDate.slice(6, 8)}/${rawDate.slice(4, 6)}/${rawDate.slice(0, 4)} ${rawDate.slice(9)}`;

		const output = `<span>${name}</span> <span>${currentPrice.toFixed(2)} ${currencySymbol}</span> <span class="${changePct > 0 ? 'text-green' : 'text-alert'}">${changeSign}${Math.abs(changePct).toFixed(2)}%</span> <span>${dateStr}</span>`;

		const indexStock = document.getElementById('index-stock');
		const stockChange = document.getElementById('stock-change');
		const stockPrice = document.getElementById('stock-price');
		if (indexStock) {
			indexStock.innerHTML = output;
		}
		if (stockChange) {
			stockChange.innerHTML = `${changeSign}${Math.abs(changePct).toFixed(2)}%`;
		}
		if (stockPrice) {
			stockPrice.innerHTML = `${currentPrice.toFixed(2)} ${currencySymbol}`;
		}
	} catch (err) {
		console.error('Error fetching stock data:', err);
	}
});

document.addEventListener('DOMContentLoaded', () => {
	const submenuToggles = document.querySelectorAll('.menu-item-has-children > a > span > i');

	submenuToggles.forEach((icon) => {
		icon.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();

			const parentLink = icon.closest('a');
			const submenu = icon.closest('.menu-item-has-children').querySelector('.sub-menu');

			if (submenu) {
				submenu.classList.toggle('hidden');
				parentLink.classList.toggle('clicked');
			}
		});
	});
});
